import React from 'react';

import './RadioButton.scss';
import bem from '../../utils/bem';

const RadioButton = ({ options, onSelect, selected, onBlur, url, orientation }) => (
  <div className={bem('radio-button', {
    [orientation]: orientation
  })}>
    {options.map(option => {
      const finalUrl = url || option.url;
      if (finalUrl) {
        const component = option.component;
        return (
          <div key={option.value} className={bem('radio-button__option', {
            selected: option.value === selected?.value,
          })}>
            <div className="radio-button__control" onClick={() => onSelect(option)} role="button" />
            {component || <a href={finalUrl} target="_blank" rel="noopener noreferrer" className="radio-button__label radio-button__label-link">{option.label}</a>}
          </div>
        )
      }
      return (
        <button
          onClick={() => onSelect(option)}
          key={option.value}
          className={bem('radio-button__option', {
            selected: option.value === selected?.value,
          })}
          type="button"
          onBlur={onBlur}
        >
          <div className="radio-button__control" />
          <div className="radio-button__label">{option.label}</div>
        </button>
      );
      })}
  </div>
);
RadioButton.defaultProps = {
  onSelect: () => {},
  onBlur: () => {},
};

export default RadioButton;
